import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, delay, finalize, take, takeWhile } from 'rxjs';
import { GrupoReporte, Reporte } from 'src/app/features/data-visualization/reports/models/reporte';
import { ReportsService } from 'src/app/features/data-visualization/reports/reports.service';
import { ModalConfig } from 'src/app/shared/components/modal/modal-config';
import { PageableData } from 'src/app/shared/models/paginator';
import { TableHeader } from 'src/app/shared/models/table';
import { PageableFunctions } from 'src/app/util/pageable-functions';
import { REPORT_MESSAGES } from 'src/app/util/constantes-mensajes';
import { REPORT_LIST_HEADERS } from './report-list-headers';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.scss']
})
export class ReportListComponent implements OnInit {

  @Input() reportGroup: GrupoReporte;
  reports: Reporte[] = [];
  public modalConfig: ModalConfig;
  search$ = new BehaviorSubject<TableHeader | undefined>(undefined);
  pageable: PageableData<Reporte>;
  headers = REPORT_LIST_HEADERS;
  isLoading: boolean = false;
  isAlive: boolean = true;
  enableFilters: boolean = false;
  faFilter = faFilter;
  constructor(private reportService: ReportsService, private ngbActiveModal: NgbActiveModal) {
    this.pageable = {
      content: [],
      currentPage: 0,
      totalPages: 1,
      itemsQuantity: 0,
      totalElements: 0
    }
  }

  ngOnInit(): void {
    this.modalConfig = {
      modalTitle: `Lista de reportes - ${this.reportGroup.nombre}`,
      ...this.modalConfig,
    };
    this.isLoading = true;
    this.reportService.getReportsByFilters(this.reportGroup.uuid, this.search$, 0, 10)
      .pipe(takeWhile(() => this.isAlive),)
      .subscribe({
        next: response => {
          this.isLoading = false;
          this.pageable = PageableFunctions.getPageableData(response);
          this.reports = this.pageable.content;
        }
      });
  }

  /**
* This function toggles enableFilters property to show or hide filters
* @returns None
*/
  toggleFilters(): void {
    this.enableFilters = !this.enableFilters;
    if (!this.enableFilters) {
      this.search$.next(undefined);
    }
  }

  /**
 * Takes the page number and sends a request to get the corresponding data
 * @param {number} page
 */
  changePage(page: number): void {
    this.isLoading = true;
    const header = this.search$.value;
    this.reportService.getReportsByReportGroup(this.reportGroup.uuid, page - 1, 10, header?.key, header?.value, header?.sort)
      .pipe(
        take(1),
        delay(500),
        finalize(() => this.isLoading = false))
      .subscribe({
        next: response => {
          this.pageable = PageableFunctions.getPageableData(response);
          this.reports = this.pageable.content;
        },
        error: () => {
          this.ngbActiveModal.close({ message: REPORT_MESSAGES.GET.ERROR_REPORTS, confirmTitle: "Cerrar", isError: true });
        }
      });
  }

}
